module.exports = __webpack_public_path__ + "static/media/thumnailimg.33be5636.png";